var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33496 2V8.06H8.66496V2H7.33496Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.44465 6.15039L7.45465 9.16039C7.75465 9.46039 8.24465 9.46039 8.54465 9.16039L11.5546 6.16039L11.7046 6.28039C11.9646 6.48039 12.1846 6.70039 12.3846 6.95039L12.5046 7.10039L9.49465 10.1104C9.12465 10.4804 8.64465 10.6804 8.16465 10.7204C8.11465 10.7204 8.06465 10.7204 8.01465 10.7204C7.96465 10.7204 7.91465 10.7204 7.86465 10.7204C7.37465 10.6804 6.90465 10.4804 6.52465 10.1104L3.51465 7.10039L3.63465 6.95039C3.83465 6.71039 4.05465 6.48039 4.30465 6.28039L4.45465 6.16039L4.44465 6.15039Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6649 10.6992V12.0292C12.6649 12.3892 12.3749 12.6792 12.0149 12.6792H3.98488C3.62488 12.6692 3.33488 12.3792 3.33488 12.0192V10.6992H2.00488V12.0992C2.00488 13.1492 2.85488 13.9992 3.90488 13.9992H12.0949C13.1449 13.9992 13.9949 13.1492 13.9949 12.0992V10.6992H12.6649Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.8dbcc960c5fb307910f7c424118f9195.svg";
export { ForwardRef as ReactComponent };